// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.measureExpand--wOcA3 {
  display: block;
}[dir] .measureExpand--wOcA3 {
  background: #f5f5f5;
  padding: 15px;
}

.treeContainer--NTpUN {
  --tree-color: rgb(var(--selected_color));
  --tree-mask-bg: #f5f5f5;
  position: relative;
  list-style: none;
}

[dir] .treeContainer--NTpUN {
  padding-top: 5px;
}

[dir=ltr] .treeContainer--NTpUN {
  border-left: 2px solid var(--tree-color, rgba(0, 0, 0, 0.2));
  margin-left: 10px;
  padding-left: 12px;
}

[dir=rtl] .treeContainer--NTpUN {
  border-right: 2px solid var(--tree-color, rgba(0, 0, 0, 0.2));
  margin-right: 10px;
  padding-right: 12px;
}

@media screen and (max-width: 767px) {
  [dir=ltr] .treeContainer--NTpUN {
    margin-left: 8px;
    padding-left: 12px;
  }
  [dir=rtl] .treeContainer--NTpUN {
    margin-right: 8px;
    padding-right: 12px;
  }
}

.appMenuList--I8wus {
  list-style: none;
}

[dir] .appMenuList--I8wus {
  margin-bottom: 0;
}

[dir=ltr] .appMenuList--I8wus {
  padding-left: 40px;
}

[dir=rtl] .appMenuList--I8wus {
  padding-right: 40px;
}

.subCategoryList--ynJ48 {
  position: relative;
}

[dir] .subCategoryColumn--Vy0YS {
  margin-bottom: 10px;
}

[dir] .subCategoryHeader--Z_yhR {
  margin-bottom: 0;
}

.listIcon--cmLpj {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

[dir=ltr] .listIcon--cmLpj {
  margin-right: 2px;
}

[dir=rtl] .listIcon--cmLpj {
  margin-left: 2px;
}

[dir] .listItem--TrmlE {
  margin-bottom: 8px;
}

.subjectNameLevel2--DwV8H {
  font-style: normal;
  color: #000 !important;
  position: relative;
  font-size: 16px;
  font-weight: 300;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

[dir] .subjectNameLevel2--DwV8H {
  padding: 5px 8px;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
  background: white;
}

.selectedSubMeasure--ZGDCc {
  font-weight: 700;
}

[dir] .selectedSubMeasure--ZGDCc {
  background: rgba(var(--selected_color), 0.25) !important;
  border: 1px solid rgb(var(--selected_color)) !important;
}

.subCategoryGrid--FyBC4 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

@media (min-width: 768px) {
  .subCategoryGrid--FyBC4 {
    grid-template-columns: repeat(4, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/SubCategories/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAGhB,CAJA;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EAKvB,kBAAkB;EAClB,gBAAgB;AAClB;;AATA;EAME,gBAAgB;AAGlB;;AATA;EAGE,4DAA4D;EAC5D,iBAAiB;EACjB,kBAAkB;AAIpB;;AATA;EAGE,6DAA4D;EAC5D,kBAAiB;EACjB,mBAAkB;AAIpB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EAHA;IACE,iBAAgB;IAChB,mBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAGlB;;AAJA;EAGE,gBAAgB;AAClB;;AAJA;EAEE,kBAAkB;AAEpB;;AAJA;EAEE,mBAAkB;AAEpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AAExB;;AALA;EAIE,iBAAiB;AACnB;;AALA;EAIE,gBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAElB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAGhB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AAEV;;AAbA;EAEE,gBAAgB;EAKhB,yBAAyB;EACzB,kBAAkB;EAIlB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAGlB;;AAJA;EAEE,wDAAwD;EACxD,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".measureExpand {\n  display: block;\n  background: #f5f5f5;\n  padding: 15px;\n}\n\n.treeContainer {\n  --tree-color: rgb(var(--selected_color));\n  --tree-mask-bg: #f5f5f5;\n  border-left: 2px solid var(--tree-color, rgba(0, 0, 0, 0.2));\n  margin-left: 10px;\n  padding-left: 12px;\n  padding-top: 5px;\n  position: relative;\n  list-style: none;\n}\n\n@media screen and (max-width: 767px) {\n  .treeContainer {\n    margin-left: 8px;\n    padding-left: 12px;\n  }\n}\n\n.appMenuList {\n  list-style: none;\n  padding-left: 40px;\n  margin-bottom: 0;\n}\n\n.subCategoryList {\n  position: relative;\n}\n\n.subCategoryColumn {\n  margin-bottom: 10px;\n}\n\n.subCategoryHeader {\n  margin-bottom: 0;\n}\n\n.listIcon {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n  margin-right: 2px;\n}\n\n.listItem {\n  margin-bottom: 8px;\n}\n\n.subjectNameLevel2 {\n  font-style: normal;\n  padding: 5px 8px;\n  color: #000 !important;\n  position: relative;\n  font-size: 16px;\n  font-weight: 300;\n  border: 1px solid #c3c3c3;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: white;\n}\n\n.selectedSubMeasure {\n  font-weight: 700;\n  background: rgba(var(--selected_color), 0.25) !important;\n  border: 1px solid rgb(var(--selected_color)) !important;\n}\n\n.subCategoryGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n@media (min-width: 768px) {\n  .subCategoryGrid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"measureExpand": `measureExpand--wOcA3`,
	"treeContainer": `treeContainer--NTpUN`,
	"appMenuList": `appMenuList--I8wus`,
	"subCategoryList": `subCategoryList--ynJ48`,
	"subCategoryColumn": `subCategoryColumn--Vy0YS`,
	"subCategoryHeader": `subCategoryHeader--Z_yhR`,
	"listIcon": `listIcon--cmLpj`,
	"listItem": `listItem--TrmlE`,
	"subjectNameLevel2": `subjectNameLevel2--DwV8H`,
	"selectedSubMeasure": `selectedSubMeasure--ZGDCc`,
	"subCategoryGrid": `subCategoryGrid--FyBC4`
};
export default ___CSS_LOADER_EXPORT___;
